import { useAvailableRoles } from '@hooks/useAvailableRoles';
export const useRolesTab = () => {
    const { availableRoles, isLoading } = useAvailableRoles();
    const data = availableRoles || [];
    const emptyMessage = 'No roles found';
    const headers = [
        {
            id: 'role',
            label: 'Role',
            render: ({ name }) => name,
            width: 60,
        },
        {
            id: 'membersAssigned',
            label: 'Members Assigned',
            render: ({ membersCount }) => membersCount,
            width: 35,
        },
    ];
    return {
        rolesTab: {
            listProps: {
                data,
                isLoading,
                emptyComponent: emptyMessage,
            },
            tableProps: {
                headers,
                data,
                isLoading,
                emptyMessage,
            },
        },
    };
};
